export enum EntitiesTypes {
  BRAND = "brand",
  ORGANISATION = "organisation"
}

export enum TaxTypes {
  BRAND_INHERIT = 0,
  ZERO_TAX = 1,
  NO_TAX = 2
}
